import styled from 'styled-components';

export const WaterTextureOverlayImage = styled.div<{
  backgroundImageUrl?: string;
  opacity?: number;
}>`
  background-image: ${({ backgroundImageUrl }) => (backgroundImageUrl ? `url(${backgroundImageUrl})` : '')};
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  opacity: ${({ opacity }) => opacity || 0.1};
`;

